import { render, staticRenderFns } from "./SalePriceDescription.vue?vue&type=template&id=7c5b7cdb&"
import script from "./SalePriceDescription.vue?vue&type=script&lang=js&"
export * from "./SalePriceDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports